// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-36549153]:not(.disabled){cursor:pointer}a.disabled[data-v-36549153]{cursor:default;pointer-events:none}", ""]);
// Exports
module.exports = exports;
